module.exports = __webpack_public_path__ + "assets/icon_cost_control_default.639fe7c0.svg";